import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useCancelarVinculoPlanejamentosTalhoes() {
  return useMutation(URL.PLANO_OPERACIONAL.CANCELAR_VINCULO, async (data: any) => {
    const response = await http.delete(URL.PLANO_OPERACIONAL.CANCELAR_VINCULO, { data });
    return response;
  });
}

export default useCancelarVinculoPlanejamentosTalhoes;
